import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import CommonContainer from '../CommonContainer'
import { addEmailDomainWithWeightage, deleteEmailDomain, getAllEmailsDomainWeights, getMatchingThreshold, updateThreshold } from '../../redux/actions/vendor'
import { toast } from '../CommonComponents/ToastComponent/toast'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { Table } from 'rsuite'
import ModalComponent from '../CommonComponents/Modal'

const { Column, HeaderCell, Cell, Pagination } = Table

const ThresholdSettings = () => {
    const [value, setValue] = useState(40)
    const [prevValue, setPrevValue] = useState(null)
    const [allEmailsDomain, setAllEmailDomain] = useState([])
    const [emailDomains, setEmailDomains] = useState({ emailDomain: '', weightage: null })
    const [isLoadingDomains, setIsLoadingDomains] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [showError, setShowError] = useState('')
    const [onDeleteModal, setShowDeleteModal] = useState(false)
    const [backdrop, setBackdrop] = React.useState('static');
    const [deletedId, setDeletedId] = useState(null)


    const DOMAIN_REGEX = /^(?=.{1,253}$)(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.(?!-)[A-Za-z0-9-]{1,63}(?<!-))*$/


    const SelectorCell = ({ rowData, dataKey, onDelete, onShowChildren, ...props }) => {
        return (
            <Cell {...props} id="actionButton" className="rs-table-cell-content" fixed style={{ display: 'flex', alignItems: 'center' }}>
                <button type="button" className="report_small_button_danger" onClick={(e) => { onDelete(e, rowData?.id) }} >Delete</button>
            </Cell>
        )
    }

    const dispatch = useDispatch()

    const headers = [
        { name: 'emailDomain', label: 'Domain' },
        { name: 'weightage', label: 'Weight' },
    ]

    const onSave = async () => {
        if (prevValue === value) {
            toast.show({
                title: 'Warning',
                description: 'Already This Value Is Saved!'
            })
            return;
        }
        await dispatch(updateThreshold(value)).then((res) => {
            getMatchingThresholdValue()
            toast.show({
                title: 'Success',
                description: 'Successfully Updated Threshold Value'
            })
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Updated Threshold Value'
            })
        })
    }

    const updateThresholdHandler = (e) => {
        setValue(e.target.value)
    }

    const setThresholdValue = useCallback(async () => {
        await dispatch(updateThreshold(40)).then((res) => {

        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Set Threshold Value'
            })
        })
    }, [])

    const getMatchingThresholdValue = useCallback(async () => {
        await dispatch(getMatchingThreshold()).then((res) => {
            if (res.length === 0) {
                setThresholdValue()
            } else {
                setValue(res[0]?.value)
                setPrevValue(res[0]?.value)
            }
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Get Threshold Value'
            })
        })
    }, [])

    const getAllEmailsDomainWithWeightage = useCallback(async () => {
        await dispatch(getAllEmailsDomainWeights()).then((res) => {
            if (res.length === 0) {
                setAllEmailDomain([])
            } else {
                let result = res.map(element => {
                    let obj = {}
                    obj.id = element.id
                    obj.emailDomain = JSON?.parse(element.value).emailDomain
                    obj.weightage = JSON?.parse(element.value).weightage

                    return obj
                });
                setAllEmailDomain(result)
            }
        }).catch((err) => {
            setAllEmailDomain([])

            toast.show({
                title: 'Warning',
                description: 'Unable To Get Threshold Value'
            })
        })
    }, [])

    const addEmailDomainWeightageHandler = async (update = false) => {
        let idToUpdate = null
        if (update) {
            idToUpdate = allEmailsDomain.filter(domain => domain.emailDomain === emailDomains.emailDomain)
        }
        await dispatch(addEmailDomainWithWeightage(emailDomains, update, idToUpdate?.[0]?.id)).then((res) => {
            getAllEmailsDomainWithWeightage()
            setShowModal(false)
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Get Email Domain And Weightage Value'
            })
        })
    }

    const onAddEmailDomainAndWeightage = async () => {
        let IsValid = DOMAIN_REGEX.test(emailDomains?.emailDomain)
        if (!emailDomains?.emailDomain || !emailDomains?.weightage) {
            setShowErrorModal(true)
            setShowError('Please enter details correctly')
            return
        }

        if (emailDomains?.weightage < 1 || emailDomains?.weightage > 8) {
            setShowErrorModal(true)
            setShowError('Please add weightage between 1 to 8')
            return
        }

        if (!IsValid) {
            setShowErrorModal(true)
            setShowError('Please enter email domain correctly')
            return
        }

        const checkIfEmailDomainExist = allEmailsDomain.findIndex(domain => domain?.emailDomain === emailDomains?.emailDomain)

        if (checkIfEmailDomainExist !== -1) {
            setShowError('This email domain already exists. Do you want to update the weight for this email domain?')
            setShowModal(true)
            return
        }
        await addEmailDomainWeightageHandler()
    }

    const headerColumns = () => {
        return headers.map(col => {
            if (col.name === 'value') {
                return (
                    <Column
                        resizable
                        sortable={true}
                        key={col.name}
                    >
                        <HeaderCell className='text-black mb-0 fw-bold'>{col.label}</HeaderCell>
                        <Cell dataKey={col.name} />
                    </Column>
                )
            }
            return (
                <Column
                    resizable
                    sortable={true}
                    key={col.name}
                >
                    <HeaderCell className='text-black mb-0 fw-bold'>{col.label}</HeaderCell>
                    <Cell dataKey={col.name} />
                </Column>
            )
        })
    }

    const deleteDomainHandler = async () => {
        await dispatch(deleteEmailDomain(deletedId)).then((res) => {
            setShowDeleteModal(false)
            getAllEmailsDomainWithWeightage()
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Get Email Domain And Weightage Value'
            })
        })
    }

    const onDeleteDomain = async (e, id) => {
        setShowDeleteModal(true)
        setShowError("Do you want to delete this email domain?")
        setDeletedId(id)

    }

    const onModalClose = () => {
        setShowModal(false)
        setShowErrorModal(false)
        setShowDeleteModal(false)
    }

    useEffect(() => {
        getMatchingThresholdValue()
        getAllEmailsDomainWithWeightage()
    }, [])

    return (
        <CommonContainer>
            {showModal && (
                <ModalComponent
                    backdrop={backdrop}
                    open={showModal}
                    handleClose={onModalClose}
                    modalTitle={showError}
                    size={`md`}>
                    <div className="d-flex column-gap-3">
                        <button onClick={onModalClose} className="report_small_button_grey">Cancel</button>
                        <button onClick={() => { addEmailDomainWeightageHandler(true) }} className="report_small_button_success">Update</button>
                    </div>
                </ModalComponent>
            )}
            {showErrorModal && (
                <ModalComponent
                    backdrop={backdrop}
                    open={showErrorModal}
                    handleClose={onModalClose}
                    modalTitle={showError}
                    size={`md`}>
                    <div className="d-flex column-gap-3">
                        <button onClick={onModalClose} className="report_small_button_grey">Ok</button>
                    </div>
                </ModalComponent>
            )}
            {onDeleteModal && (
                <ModalComponent
                    backdrop={backdrop}
                    open={onDeleteModal}
                    handleClose={onModalClose}
                    modalTitle={showError}
                    size={`md`}>
                    <div className="d-flex column-gap-3">
                        <button onClick={onModalClose} className="report_small_button_grey">Cancel</button>
                        <button onClick={() => {deleteDomainHandler()}} className="report_small_button_danger">Delete</button>
                    </div>
                </ModalComponent>
            )}
            <h2 className='mb-4 text-dark-emphasis'>Matching Threshold</h2>
            <div className='d-flex flex-column row-gap-3 col-5'>
                <input type='number' className="search-input w-50 fs-3" value={value} onChange={(e) => { updateThresholdHandler(e) }} />
                <button className='bg-green p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end w-25' onClick={onSave}>Save</button>
            </div>

            <div className=' mt-5'>
                <h2 className='mb-4 text-dark-emphasis'>Email Domain</h2>
                <div className='d-flex column-gap-4 col-5 align-items-center' >
                    <input type='text' className="search-input w-50 fs-3" onChange={(e) => { setEmailDomains(prevState => { return { ...prevState, emailDomain: e.target.value } }) }} />
                    <input type='number' min={1} max={8} className="search-input w-25 fs-3" onChange={(e) => { setEmailDomains(prevState => { return { ...prevState, weightage: e.target.value } }) }} />
                    <button className='bg-green p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end w-25' style={{ height: 38 }} onClick={onAddEmailDomainAndWeightage}>Save</button>
                </div>
            </div>

            <div className={`record-body mt-5 border ${isLoadingDomains ? 'loading' : ''}`}>
                {isLoadingDomains && <LoaderComponent />}
                <Table
                    virtualized
                    autoHeight
                    affixHeader={true}
                    data={allEmailsDomain}
                // sortType={sortType}
                // sortColumn={sortColumn}
                // onSortColumn={handleSortColumn}
                >
                    {headerColumns()}
                    <Column
                        width={250}
                        key="action"
                        align="center"
                    >
                        <HeaderCell className='fw-bold text-black '>Action</HeaderCell>
                        <SelectorCell onDelete={onDeleteDomain} />
                    </Column>
                </Table>
                {/* <div className="pagination">
                    <Pagination
                        prev
                        next
                        first
                        last
                        showInfo
                        maxButtons={5}
                        lengthMenu={[
                            {
                                label: '5',
                                value: 5,
                            },
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '25',
                                value: 25,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                        ]}
                        displayLength={limit}
                        total={totalMatchedChildRecords}
                        limit={limit}
                        activePage={page}
                        onChangePage={(event) => { onChangePageHandler(event) }}
                        onChangeLength={handleChangeLimit}
                    />
                </div> */}
            </div>
        </CommonContainer>
    )
}

export default ThresholdSettings;